<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.accidentsCount.lessThanSuspensionThreeDays.$invalid 
      || $v.accidentsCount.moreThanSuspensionFourDays.$invalid
      || $v.accidentsCount.resultMemo.$invalid 
      || $v.accidentsCount.actionMemo.$invalid">
      <div v-if="$v.accidentsCount.lessThanSuspensionThreeDays.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">休業3日以内：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.accidentsCount.lessThanSuspensionThreeDays.$invalid && !$v.accidentsCount.lessThanSuspensionThreeDays.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.accidentsCount.lessThanSuspensionThreeDays.$invalid && $v.accidentsCount.lessThanSuspensionThreeDays.numeric && !$v.accidentsCount.lessThanSuspensionThreeDays.between" validation="between" valueMin="0" valueMax="999"/>
      </div>
      <div v-if="$v.accidentsCount.moreThanSuspensionFourDays.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">休業4日以上：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.accidentsCount.moreThanSuspensionFourDays.$invalid && !$v.accidentsCount.moreThanSuspensionFourDays.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.accidentsCount.moreThanSuspensionFourDays.$invalid && $v.accidentsCount.moreThanSuspensionFourDays.numeric && !$v.accidentsCount.moreThanSuspensionFourDays.between" validation="between" valueMin="0" valueMax="999"/>
      </div>
      <div v-if="$v.accidentsCount.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ　　　　：</span>
        <ValidationErrorMessage v-show="$v.accidentsCount.resultMemo.$invalid && !$v.accidentsCount.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.accidentsCount.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション　　　：</span>
        <ValidationErrorMessage v-show="$v.accidentsCount.actionMemo.$invalid && !$v.accidentsCount.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">労災発生件数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50%;">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>休業3日以内</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.accidentsCount.$model.lessThanSuspensionThreeDays" type="text" name="accidentsCount.lessThanSuspensionThreeDays" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">件</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>休業4日以上</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.accidentsCount.$model.moreThanSuspensionFourDays" type="text" name="accidentsCount.moreThanSuspensionFourDays" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">件</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            労災発生件数
            <strong><Currency :value="this.calAchievementAccidentsCount"/></strong>件
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="accidentsCount.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(accidentsCount.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="accidentsCount.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
    Currency,
  },
  props: {
    // 表示年度の労災発生件数データ
    accidentsCount: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "件",
    }
  },
  computed: {
    calAchievementAccidentsCount() {
      if ( !(this.accidentsCount.lessThanSuspensionThreeDays!=null && this.accidentsCount.moreThanSuspensionFourDays!=null) ) {
        return null;
      }else if ( String(this.accidentsCount.lessThanSuspensionThreeDays).length * String(this.accidentsCount.moreThanSuspensionFourDays).length == 0) {
        return null;
      }else if ( isNaN(this.accidentsCount.lessThanSuspensionThreeDays) || isNaN(this.accidentsCount.moreThanSuspensionFourDays)) {
        return null;
      }else{
        return Number(this.accidentsCount.lessThanSuspensionThreeDays) + Number(this.accidentsCount.moreThanSuspensionFourDays);
      }
    }
  },
  validations: {
    accidentsCount: {
      lessThanSuspensionThreeDays : { 
        numeric,
        between: between(0,999), 
      }, // 休業3日以内
      moreThanSuspensionFourDays : {
        numeric,
        between: between(0,999),
      },  // 休業4日以上
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    accidentsCount() {
      this.inputAccidentsCount();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputAccidentsCount() {
      this.$emit("change-accidents-count", {
        accidentsCount: this.accidentsCount,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
